import React, { useEffect, useState } from "react";
import { Controller, FormProvider, useForm } from "react-hook-form";
import { Textbox } from "./Textbox";
import { Button, Form, FormLabel, InputGroup, Table } from "react-bootstrap";
import {
  faEnvelope,
  faMobile,
  faPencil,
  faSave,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { SelectBox } from "./SelectBox";
import { API_URL_ENDPOINT } from "../appsetting";
import { useApi } from "../helpers/useApi";
import { gstRateMap, sendError, sendSuccess } from "../helpers/Helper";
import { faInternetExplorer } from "@fortawesome/free-brands-svg-icons";
import Skeleton from "react-loading-skeleton";
import { useAuth } from "../store/AuthContext";
import SelectSearch from "./SelectSearch";
const LoadBilty = ({ onBiltyCreated, LoadDetail }) => {
  const callApi = useApi();
  const methods = useForm();
  const {
    control,
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
    watch,
    setValue,
  } = methods;
  const isInsured = watch("isInsured");
  const [currentCompany, setCurrentCompany] = useState({});
  const [dataLoading, setDataLoading] = useState(false);
  const [subTotal, setSubTotal] = useState(0);
  const [total, setTotal] = useState(0);

  const [fromCity, setFromCity] = useState([]);
  const [toCity, setToCity] = useState([]);

  const [products, setProducts] = useState([]);
  const [currentProduct, setCurrentProduct] = useState({
    materialName: "",
    hsnCode: "",
    packagingType: "",
    actualWeight: "",
    chargeWeight: "",
    unit: "",
    noofArtical: "",
    chargeRate: "1",
    isFixedCharge: false,
    rate: "",
    totalAmount: "",
  });

  const [productErrors, setProductErrors] = useState({});

  const handleProductChange = (name, value) => {
    const updatedProduct = { ...currentProduct, [name]: value };

    updatedProduct.totalAmount = calculateTotalAmount(updatedProduct);

    setCurrentProduct(updatedProduct);
    setProductErrors((prev) => ({ ...prev, [name]: null }));
  };

  const calculateTotalAmount = ({
    chargeRate,
    rate,
    actualWeight,
    chargeWeight,
  }) => {
    // console.log(chargeRate,
    // rate,
    // actualWeight,
    // chargeWeight,)
    if (!chargeRate || !rate || (!actualWeight && !chargeWeight)) return 0;

    const parsedRate = parseFloat(rate || 0);
    const parsedActualWeight = parseFloat(actualWeight || 0);
    const parsedChargeWeight = parseFloat(chargeWeight || 0);

    if (chargeRate === "1") {
      return parsedActualWeight * parsedRate;
    } else if (chargeRate === "2") {
      return parsedChargeWeight * parsedRate;
    } else if (chargeRate === "3") {
      return rate;
    }

    return 0;
  };

  const calculateMainTotalAmount = () => {
    const basicFreight = parseFloat(watch("basicFreight") || 0);
    const loadingUnloadingCharge = parseFloat(
      watch("loadingUnloadingCharge") || 0
    );
    const kantaCharge = parseFloat(watch("kantaCharge") || 0);
    const otherCharge = parseFloat(watch("otherCharge") || 0);
    const gstRateKey = watch("gstRate") || "0";
    const gstPercent = gstRateMap[gstRateKey];
    const subTotal =
      basicFreight + loadingUnloadingCharge + kantaCharge + otherCharge;
    const gstAmount = subTotal * (gstPercent / 100);
    const total = subTotal + gstAmount;
    setSubTotal(subTotal);
    setTotal(total);
  };

  useEffect(() => {
    getCurrentCompany();
    var data = LoadDetail;
    reset({
      consignorCompanyName: data?.shipper?.fullName,
      // consignorGST: data.consignorGST,
      consignorAddress: data?.sourceAddress,
      // consigneeName: data.consigneeCompanyName,
      // consigneeGST: data.consigneeGST,
      consigneeAddress: data?.destinationAddress,
      // invoiceNumber: data.invoiceNumber,
      // invoiceDate: data.invoiceDate === "" ? null : data.invoiceDate,
      // amountAndEWayBillNumber: data.eWayBillNumber,
      // vehicleNumber: data.truckNumber,
      // ownerName: data.truckOwnerName,
      // loadType: data.loadType,
      // driverName: data.driverName,
      // contactNumber: data.driverContactNumber,
      // dlNumber: data.driverLicenseNumber,
      // type: data.freightDetail,
      // basicFreight: parseFloat(data.basicFreight) || 0,
      // loadingUnloadingCharge: parseFloat(data.loadingUnloadingCharge) || 0,
      // kantaCharge: parseFloat(data.kantaCharge) || 0,
      // otherCharge: parseFloat(data.otherCharge) || 0,
      // gstRate: data.gstRate,
      // gstPayBy: data.gstPayBy,
      // advanceAmountPaid: data.advancePaidAmount === "" ? 0 : data.advanceAmountPaid,
      isInsured: "false",
      // insuranceCompanyName: data.insuranceCompanyName,
      // policyNumber: data.policyNumber,
      // insuranceAmount: data.insuranceAmount,
      // insuranceDate: data.insuranceDate,
      // riskType: data.riskType,
      tranportMode: "1",
      // detentionChargeType: data.chargeType === "" ? null : data.chargeType,
      // detentionCharges: parseFloat(data.detentionCharge) || 0,
      // otherRemarks: data.otherRemark,
      from: data?.source?.id,
      to: data?.destination?.id,
      fromText: data?.source?.placeName,
      toText: data?.destination?.placeName,
    });
    const rateType = data.rateType === "Fixed" ? "3" : "1";
    const rate = data?.rateAmount ?? "";
    const wt = data?.weightInTons ?? "";
    var total = calculateTotalAmount({chargeRate : rateType, rate : rate, actualWeight : wt, chargeWeight : wt});
    setCurrentProduct({
      materialName: data?.product ?? "",
      hsnCode: "",
      packagingType: "",
      actualWeight: data?.weightInTons ?? "",
      chargeWeight: data?.weightInTons ?? "",
      unit: "2",
      noofArtical: "",
      chargeRate: rateType,
      rate: rate,
      totalAmount: total,
    });

    console.log("Param", LoadDetail)
  }, []);

  const addProduct = () => {
    const requiredFields = [
      "materialName",
      // "hsnCode",
      "actualWeight",
      "chargeWeight",
      "unit",
      "chargeRate",
      "rate",
    ];

    const newErrors = {};
    requiredFields.forEach((field) => {
      if (!currentProduct[field]) {
        newErrors[field] = `${field} is required`;
      }
    });

    if (Object.keys(newErrors).length > 0) {
      setProductErrors(newErrors);
      return;
    }

    const productWithId = {
      ...currentProduct,
      id: Date.now() + Math.random().toString(16).slice(2),
    };

    // setProducts((prev) => [...prev, productWithId]);
    setProducts((prev) => {
      const updatedProducts = [...prev, productWithId];
      // run doSum after setting
      setTimeout(() => doSum(updatedProducts), 0); // optionally pass updatedProducts
      return updatedProducts;
    });

    setCurrentProduct({});
    setProductErrors({});
  };

  const doSum = (customProducts) => {
    // Calculate total basic freight using the `total` key of each product
    const list = customProducts || products;
    const totalFreight = list.reduce(
      (sum, p) => sum + (parseFloat(p.totalAmount) || 0),
      0
    );
    reset({
      basicFreight: totalFreight.toFixed(2),
    });
    calculateMainTotalAmount();
  };

  const editProduct = (id) => {
    const productToEdit = products.find((p) => p.id === id);
    if (productToEdit) {
      const updatedProducts = products.filter((p) => p.id !== id);
      setCurrentProduct(productToEdit);
      setProducts(updatedProducts);
      doSum(updatedProducts);
    }
  };

  const deleteProduct = (id) => {
    const updatedProducts = products.filter((p) => p.id !== id);
    setProducts(updatedProducts);
    doSum(updatedProducts);
    calculateMainTotalAmount();
  };

  const onBiltySubmit = async (data) => {
    const payload = {
      consignorName: data.consignorCompanyName,
      consignorGST: data.consignorGST,
      consignorAddress: data.consignorAddress,
      consigneeName: data.consigneeCompanyName,
      consigneeGST: data.consigneeGST,
      consigneeAddress: data.consigneeAddress,
      invoiceNumber: data.invoiceNumber,
      invoiceDate: data.invoiceDate === "" ? null : data.invoiceDate,
      amountAndEWayBillNumber: data.eWayBillNumber,
      vehicleNumber: data.truckNumber,
      ownerName: data.truckOwnerName,
      loadType: data.loadType,
      driverName: data.driverName,
      contactNumber: data.driverContactNumber,
      dlNumber: data.driverLicenseNumber,
      type: data.freightDetail,
      basicFreight: parseFloat(data.basicFreight) || 0,
      loadingUnloadingCharge: parseFloat(data.loadingUnloadingCharge) || 0,
      kantaCharge: parseFloat(data.kantaCharge) || 0,
      otherCharge: parseFloat(data.otherCharge) || 0,
      gstRate: data.gstRate,
      gstPayBy: data.gstPayBy,
      advanceAmountPaid:
        data.advancePaidAmount === "" ? 0 : data.advanceAmountPaid,
      isInsured: data.isInsured === ("true" || true),
      insuranceCompanyName: data.insuranceCompanyName,
      policyNumber: data.policyNumber,
      insuranceAmount: data.insuranceAmount,
      insuranceDate: data.insuranceDate,
      riskType: data.riskType,
      transportMode: data.tranportMode,
      detentionChargeType: data.chargeType === "" ? null : data.chargeType,
      detentionCharges: parseFloat(data.detentionCharge) || 0,
      otherRemarks: data.otherRemark,
      from: parseInt(data.from) || 0,
      to: parseInt(data.to) || 0,
      items: products?.map((product) => ({
        materialName: product.materialName || "",
        hsnCode: product.hsnCode || "",
        packagingType: parseInt(product.packagingType) || 0,
        actualWeight: parseFloat(product.actualWeight) || 0,
        chargeWeight: parseFloat(product.chargeWeight) || 0,
        unit: parseInt(product.unit) || 0,
        articalQuantity: parseInt(product.noofArtical) || 0,
        chargeType: parseInt(product.chargeRate) || 0,
        isFixed: product.isFixedCharge || false,
        rate: parseFloat(product.rate) || 0,
        totalAmount: parseFloat(product.totalAmount) || 0,
      })),
    };
    console.log("Data", payload);
    try {
      const response = await callApi(API_URL_ENDPOINT.Bilty, {
        method: "POST",
        data: payload,
      });
      if (response.status) {
        sendSuccess(response.message);
        reset();
        onBiltyCreated();
      } else {
        throw Error(response.message || "Something Went Wrong");
      }
    } catch (ex) {
      sendError(ex.message);
    }
  };

  const getCurrentCompany = async () => {
    try {
      setDataLoading(true);
      const response = await callApi(
        API_URL_ENDPOINT.Company + `/current-company`
      );
      if (response.status) {
        if (response?.data == null) {
          return;
        }
        setCurrentCompany(response?.data ?? {});
      } else {
        throw new Error(response.message);
      }
    } catch {
      setCurrentCompany({});
    } finally {
      setDataLoading(false);
    }
  };

  const LoadPoints = async (gst, point) => {
    if (point === "TO") {
      setToCity([]);
    } else if (point === "FROM") {
      setFromCity([]);
    }
    if (gst?.length !== 15) return;

    const stateCode = gst.substring(0, 2);

    try {
      const filters = [];
      if (stateCode) filters.push(`StateGSTCode:${stateCode}`);

      const queryParams = [
        filters.length ? `filters=${filters.join(",")}` : null,
        `pageNo=1`,
        `pageSize=2000`,
        `sortOrder=desc`,
      ]
        .filter(Boolean)
        .join("&");

      const response = await callApi(
        `${API_URL_ENDPOINT.Pincodes}?${queryParams}`
      );

      if (response.status) {
        const cityList = response.data?.items || [];

        if (point === "TO") {
          setToCity(cityList);
        } else if (point === "FROM") {
          setFromCity(cityList);
        }
      }
    } catch {
      if (point === "TO") {
        setToCity([]);
      } else if (point === "FROM") {
        setFromCity([]);
      }
    }
  };

  return (
    <div>
      {/* <div style={{ background: "#f5f8fb" }} className="mb-2 row">
        <strong style={{ fontSize: 20 }} className="w-100 d-block px-2 text-center">
          Company Detail
        </strong>
      </div> */}
      <div className="d-flex">
        <div className="mb-2 w-100">
          <div className="w-100 pb-2">
            <h5 className="text-center">
              {dataLoading ? (
                <Skeleton height={30} width={200} />
              ) : (
                currentCompany?.company?.companyName
              )}{" "}
            </h5>
            <div className="d-flex align-items-center pb-1 justify-content-center">
              <div className="me-5 d-flex align-items-center">
                {dataLoading ? (
                  <Skeleton height={20} width={200} />
                ) : (
                  <>
                    <strong style={{ fontSize: 16 }}>Brach Code- </strong>
                    <span>{currentCompany?.branchCode || "N/A"}</span>
                  </>
                )}
              </div>
              <div className="me-5 d-flex align-items-center">
                {dataLoading ? (
                  <Skeleton height={20} width={200} />
                ) : (
                  <>
                    <strong style={{ fontSize: 16 }}>Reg. Number-</strong>
                    <span>
                      {currentCompany?.company?.transportRegNumber || "N/A"}
                    </span>
                  </>
                )}
              </div>
              <div className="me-5 d-flex align-items-center">
                {dataLoading ? (
                  <Skeleton height={20} width={200} />
                ) : (
                  <>
                    <strong style={{ fontSize: 16 }}>Jurisdiction-</strong>
                    <span>{currentCompany?.company?.jurisdiction}</span>
                  </>
                )}
              </div>
              <div className="me-5 d-flex align-items-center">
                {dataLoading ? (
                  <Skeleton height={20} width={200} />
                ) : (
                  <>
                    <strong style={{ fontSize: 16 }}>GST-</strong>
                    <span>{currentCompany?.company?.gstNumber}</span>
                  </>
                )}
              </div>
              <div className="me-5 d-flex align-items-center">
                {dataLoading ? (
                  <Skeleton height={20} width={200} />
                ) : (
                  <>
                    <strong style={{ fontSize: 16 }}>PAN-</strong>
                    <span>{currentCompany?.company?.panNumber}</span>
                  </>
                )}
              </div>
            </div>
            <div className="d-flex align-items-center justify-content-center">
              <div className="me-5 d-flex align-items-center">
                {dataLoading ? (
                  <Skeleton height={20} width={200} />
                ) : (
                  <>
                    <FontAwesomeIcon icon={faMobile} className="me-2" />
                    <span>{currentCompany?.company?.mobile || "N/A"}</span>
                  </>
                )}
              </div>
              <div className="me-5 d-flex align-items-center">
                {dataLoading ? (
                  <Skeleton height={20} width={200} />
                ) : (
                  <>
                    <FontAwesomeIcon icon={faEnvelope} className="me-2" />
                    <span>{currentCompany?.company?.email || "N/A"}</span>
                  </>
                )}
              </div>
              <div className="me-5 d-flex align-items-center">
                {dataLoading ? (
                  <Skeleton height={20} width={200} />
                ) : (
                  <>
                    <FontAwesomeIcon
                      icon={faInternetExplorer}
                      className="me-2"
                    />
                    <span>{currentCompany?.company?.website || "N/A"}</span>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {currentCompany && !dataLoading && (
        <FormProvider {...methods}>
          <form onSubmit={handleSubmit(onBiltySubmit)}>
            <div className="row">
              <div className="col-md-6">
                <div style={{ background: "#f5f8fb" }} className="row">
                  <strong
                    style={{ fontSize: 20 }}
                    className="w-100 d-block px-2"
                  >
                    Consignor Detail
                  </strong>
                </div>
                <div className="my-2">
                  <Textbox
                    Label="Company Name"
                    name={"consignorCompanyName"}
                    Placeholder="Company Name"
                    validationRules={{ required: "Company Name is required" }}
                    register={register}
                    errors={errors}
                    watch={watch}
                  />
                </div>
                <div className="my-2">
                  <Textbox
                    Label="GST Number"
                    disabled={true}
                    name={"consignorGST"}
                    onBlur={(e) => LoadPoints(e.target.value.trim(), "FROM")}
                    Placeholder="GST Number"
                    validationRules={{
                      required: "GST Number is required",
                      pattern: {
                        value:
                          /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
                        message: "Invalid GST Number",
                      },
                    }}
                    register={register}
                    errors={errors}
                    watch={watch}
                  />
                </div>
                <div className="my-2">
                  <Textbox
                    Label="Address"
                    name={"consignorAddress"}
                    Placeholder="Address"
                    validationRules={{ required: "Address is required" }}
                    register={register}
                    errors={errors}
                    watch={watch}
                  />
                </div>
                <div className="my-2">
                  <Textbox
                    name={"from"}
                    Type="hidden"
                    register={register}
                    errors={errors}
                    watch={watch}
                  />
                  <Textbox
                    Label="From"
                    name={"fromText"}
                    Placeholder="From"
                    disabled={true}
                    validationRules={{ required: "From is required" }}
                    register={register}
                    errors={errors}
                    watch={watch}
                  />
                </div>
              </div>

              <div className="col-md-6">
                <div style={{ background: "#f5f8fb" }} className="row">
                  <strong
                    style={{ fontSize: 20 }}
                    className="w-100 d-block px-2"
                  >
                    Consignee Detail
                  </strong>
                </div>
                <div className="my-2">
                  <Textbox
                    Label="Company Name"
                    name={"consigneeCompanyName"}
                    Placeholder="Company Name"
                    validationRules={{ required: "Company Name is required" }}
                    register={register}
                    errors={errors}
                    watch={watch}
                  />
                </div>
                <div className="my-2">
                  <Textbox
                    Label="GST Number"
                    name="consigneeGST"
                    disabled={true}
                    onBlur={(e) => LoadPoints(e.target.value.trim(), "TO")}
                    Placeholder="GST Number"
                    validationRules={{
                      required: "GST Number is required",
                      pattern: {
                        value:
                          /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
                        message: "Invalid GST Number",
                      },
                    }}
                    register={register}
                    errors={errors}
                    watch={watch}
                  />
                </div>
                <div className="my-2">
                  <Textbox
                    Label="Address"
                    name={"consigneeAddress"}
                    Placeholder="Delivery Address"
                    validationRules={{ required: "Address is required" }}
                    register={register}
                    errors={errors}
                    watch={watch}
                  />
                </div>
                <div className="my-2">
                   <Textbox
                    name={"to"}
                    Type="hidden"
                    register={register}
                    errors={errors}
                    watch={watch}
                  />
                  <Textbox
                    Label="To"
                    name={"toText"}
                    Placeholder="To"
                    disabled={true}
                    validationRules={{ required: "Required" }}
                    register={register}
                    errors={errors}
                    watch={watch}
                  />
                </div>
              </div>
            </div>

            <div className="row">
              <div style={{ background: "#f5f8fb" }} className="mt-4">
                <strong style={{ fontSize: 20 }} className="w-100 d-block">
                  Material Detail
                </strong>
              </div>
              <div className="my-2 col-md-3">
                <Form.Label className="mb-0">
                  Material Name <span style={{ color: "red" }}>*</span>
                </Form.Label>
                <Form.Control
                  disabled={false}
                  className="shadow-none"
                  placeholder="Material Name"
                  type="text"
                  onChange={(e) =>
                    handleProductChange("materialName", e.target.value)
                  }
                  value={currentProduct?.materialName || ""}
                />
                {productErrors?.materialName && (
                  <>
                    <span className="text-danger" style={{ fontSize: 14 }}>
                      Material Name is Required
                    </span>
                  </>
                )}
              </div>
              <div className="my-2 col-md-2">
                <Form.Label className="mb-0">HSN Code</Form.Label>
                <Form.Control
                  disabled={false}
                  className="shadow-none"
                  placeholder="HSN Code"
                  type="text"
                  onChange={(e) =>
                    handleProductChange("hsnCode", e.target.value)
                  }
                  value={currentProduct?.hsnCode || ""}
                />
                {productErrors?.hsnCode && (
                  <>
                    <span className="text-danger" style={{ fontSize: 14 }}>
                      HSN Code is Required
                    </span>
                  </>
                )}
              </div>
              <div className="my-2 col-md-3">
                <Form.Label className="mb-0">Packaging Type</Form.Label>
                <Form.Select
                  disabled={false}
                  className="shadow-none"
                  onChange={(e) =>
                    handleProductChange(
                      "packagingType",
                      parseInt(e.target.value)
                    )
                  }
                  value={currentProduct?.packagingType || ""}
                >
                  <option value="">Select Packaging Type</option>
                  <option value="1">Carton Box</option>
                  <option value="2">Crate</option>
                  <option value="3">Pallet</option>
                  <option value="4">Drum</option>
                  <option value="5">Bag</option>
                  <option value="6">Sack</option>
                  <option value="7">Bale</option>
                  <option value="8">Bundle</option>
                  <option value="9">Wooden Box</option>
                  <option value="10">Container</option>
                  <option value="11">Envelope</option>
                  <option value="12">Reel</option>
                  <option value="13">IBC Tank</option>
                  <option value="14">Tote</option>
                  <option value="15">Can</option>
                  <option value="16">Cylinder</option>
                  <option value="17">Roll</option>
                </Form.Select>

                {/* {productErrors?.packagingType && (
                <>
                  <span className="text-danger" style={{ fontSize: 14 }}>
                    Type is Required
                  </span>
                </>
              )} */}
              </div>
              <div className="my-2 col-md-2">
                <Form.Label className="mb-0">
                  Actual Weight <span style={{ color: "red" }}>*</span>
                </Form.Label>
                <Form.Control
                  disabled={false}
                  className="shadow-none"
                  placeholder="Actual Weight"
                  type="number"
                  onChange={(e) =>
                    handleProductChange("actualWeight", e.target.value)
                  }
                  value={currentProduct?.actualWeight || ""}
                />
                {productErrors?.actualWeight && (
                  <>
                    <span className="text-danger" style={{ fontSize: 14 }}>
                      Weight is Required
                    </span>
                  </>
                )}
              </div>
              <div className="my-2 col-md-2">
                <Form.Label className="mb-0">
                  Charge Weight <span style={{ color: "red" }}>*</span>
                </Form.Label>
                <Form.Control
                  disabled={false}
                  className="shadow-none"
                  placeholder="Charge Weight"
                  type="number"
                  onChange={(e) =>
                    handleProductChange("chargeWeight", e.target.value)
                  }
                  value={currentProduct?.chargeWeight || ""}
                />
                {productErrors?.chargeWeight && (
                  <>
                    <span className="text-danger" style={{ fontSize: 14 }}>
                      Weight is Required
                    </span>
                  </>
                )}
              </div>
              <div className="my-2 col-md-2">
                <Form.Label className="mb-0">
                  Unit <span style={{ color: "red" }}>*</span>
                </Form.Label>
                <Form.Select
                  disabled={false}
                  className="shadow-none"
                  onChange={(e) =>
                    handleProductChange("unit", parseInt(e.target.value))
                  }
                  value={currentProduct?.unit || ""}
                >
                  <option value="">Select UNIT</option>
                  <option value="1">KG</option>
                  <option value="2">Ton</option>
                  <option value="3">PCS</option>
                  <option value="4">Box</option>
                  <option value="5">Packet</option>
                  <option value="6">Bundle</option>
                  <option value="7">Bag</option>
                  <option value="8">Drum</option>
                  <option value="9">Crate</option>
                  <option value="10">Container</option>
                  <option value="11">Liter</option>
                  <option value="12">CBM</option>
                </Form.Select>

                {productErrors?.unit && (
                  <>
                    <span className="text-danger" style={{ fontSize: 14 }}>
                      UNIT is Required
                    </span>
                  </>
                )}
              </div>
              <div className="my-2 col-md-1">
                <Form.Label className="mb-0" style={{ fontSize: 12 }}>
                  No. of Artical
                </Form.Label>
                <Form.Control
                  disabled={false}
                  className="shadow-none text-center"
                  placeholder="0"
                  type="number"
                  onChange={(e) =>
                    handleProductChange("noofArtical", e.target.value)
                  }
                  value={currentProduct?.noofArtical || ""}
                />
              </div>
              <div className="my-2 col-md-4">
                <div>
                  <FormLabel className="mb-0">
                    Charge Rate <span style={{ color: "red" }}>*</span>
                  </FormLabel>
                  <div className=" py-2">
                    <div className="d-flex align-items-center justify-content-start">
                      <div className="me-3">
                        <input
                          name="chargeRate"
                          onChange={(e) =>
                            handleProductChange("chargeRate", e.target.value)
                          }
                          type="radio"
                          value={"1"}
                          checked={currentProduct?.chargeRate === "1"}
                          style={{ width: 20, height: 20 }}
                          className="form-check-input shadow-none me-2 mt-0"
                        />
                        <span>Actual Wt.</span>
                      </div>
                      <div className="me-3">
                        <input
                          name="chargeRate"
                          type="radio"
                          onChange={(e) =>
                            handleProductChange("chargeRate", e.target.value)
                          }
                          value={"2"}
                          checked={currentProduct.chargeRate === "2"}
                          style={{ width: 20, height: 20 }}
                          className="form-check-input shadow-none me-2 mt-0"
                        />
                        <span>Charge Wt.</span>
                      </div>
                      <div>
                        <input
                          name="chargeRate"
                          type="radio"
                          onChange={(e) =>
                            handleProductChange("chargeRate", e.target.value)
                          }
                          value={"3"}
                          checked={currentProduct.chargeRate === "3"}
                          style={{ width: 20, height: 20 }}
                          className="form-check-input shadow-none me-2 mt-0"
                        />
                        <span>Fixed</span>
                      </div>
                    </div>
                    {productErrors?.chargeRate && (
                      <>
                        <span className="text-danger" style={{ fontSize: 14 }}>
                          Charge Rate is Required
                        </span>
                      </>
                    )}
                  </div>
                </div>
              </div>
              <div className="my-2 col-md-2">
                <Form.Label className="mb-0">
                  Rate <span style={{ color: "red" }}>*</span>
                </Form.Label>
                <InputGroup className="rounded-none">
                  <InputGroup.Text>₹</InputGroup.Text>
                  <Form.Control
                    disabled={false}
                    className="rounded-1"
                    placeholder="Rate"
                    type="number"
                    onChange={(e) =>
                      handleProductChange("rate", e.target.value)
                    }
                    value={currentProduct?.rate || ""}
                  />
                </InputGroup>
                {productErrors?.rate && (
                  <>
                    <span className="text-danger" style={{ fontSize: 12 }}>
                      Rate is Required
                    </span>
                  </>
                )}
              </div>
              <div className="my-2 col-md-2">
                <Form.Label className="mb-0">Total Amount</Form.Label>
                <InputGroup className="rounded-none" disabled={true}>
                  <InputGroup.Text>₹</InputGroup.Text>
                  <Form.Control
                    disabled={true}
                    className="shadow-none"
                    placeholder="Total Amount"
                    type="number"
                    onChange={(e) =>
                      handleProductChange("totalAmount", e.target.value)
                    }
                    value={currentProduct?.totalAmount || ""}
                  />
                </InputGroup>
              </div>
              <div className="my-2 col-md-1">
                <Form.Label className="mb-0"></Form.Label>
                <Button variant="success" className="mt-4" onClick={addProduct}>
                  Add
                </Button>
              </div>
            </div>

            {products.length > 0 && (
              <div className="mt-4">
                <Table bordered className="text-center">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Material Name</th>
                      <th>HSN Code</th>
                      <th>Packaging Type</th>
                      <th>Weight</th>
                      <th>Unit</th>
                      <th>No. of Artical</th>
                      <th>Rate</th>
                      <th>Total Amount</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {products.map((product, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{product.materialName}</td>
                        <td>{product.hsnCode}</td>
                        <td>{product.packagingType}</td>
                        <td>{product.actualWeight}</td>
                        <td>{product.unit}</td>
                        <td>{product.noofArtical}</td>
                        <td>{product.rate}</td>
                        <td>{product.totalAmount}</td>
                        <td>
                          <Button
                            variant="primary"
                            onClick={() => editProduct(product?.id)}
                            className="btn-sm me-2"
                          >
                            <FontAwesomeIcon icon={faPencil} />
                          </Button>
                          <Button
                            variant="danger"
                            onClick={() => deleteProduct(product?.id)}
                            className="btn-sm"
                          >
                            <FontAwesomeIcon icon={faTrash} />
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            )}

            <div className="row">
              <div style={{ background: "#f5f8fb" }} className="mt-4">
                <strong style={{ fontSize: 20 }} className="w-100 d-block">
                  Invoice & E-Way Bill
                </strong>
              </div>
              <div className="col-md-4 my-2">
                <Textbox
                  Label="Invoice Number"
                  name={"invoiceNumber"}
                  Placeholder="Invoice Number"
                  // validationRules={{ required: "Invoice Number is required" }}
                  register={register}
                  errors={errors}
                  watch={watch}
                />
              </div>
              <div className="col-md-4 my-2">
                <Textbox
                  Type={"date"}
                  Label="Invoice Date"
                  name={"invoiceDate"}
                  Placeholder="Invoice Date"
                  // validationRules={{ required: "Date is required" }}
                  register={register}
                  errors={errors}
                  watch={watch}
                />
              </div>
              <div className="col-md-4 my-2">
                <Textbox
                  Label="E-way Bill Number"
                  name={"eWayBillNumber"}
                  Placeholder="E-way Bill Number"
                  register={register}
                  errors={errors}
                  watch={watch}
                />
              </div>
              <div className="col-md-4 my-2">
                <Textbox
                  Label="Truck Number"
                  name={"truckNumber"}
                  Placeholder="Truck Number"
                  // validationRules={{ required: "Truck Number is required" }}
                  register={register}
                  errors={errors}
                  watch={watch}
                />
              </div>
              <div className="col-md-4 my-2">
                <Textbox
                  Label="Owner Name"
                  name={"truckOwnerName"}
                  Placeholder="Owner Name"
                  // validationRules={{ required: "Owner Name is required" }}
                  register={register}
                  errors={errors}
                  watch={watch}
                />
              </div>
              <div className="col-md-4 my-2">
                <SelectBox
                  Label="Load Type"
                  name={"loadType"}
                  validationRules={{ required: "Load Type is required" }}
                  register={register}
                  errors={errors}
                  watch={watch}
                >
                  <option value="">Select Load Type</option>
                  <option value="1">Full Load</option>
                  <option value="2">Part Load</option>
                  <option value="3">Partial Load</option>
                </SelectBox>
              </div>
              <div className="col-md-4 my-2">
                <Textbox
                  Label="Driver Name"
                  name={"driverName"}
                  Placeholder="Driver Name"
                  // validationRules={{ required: "Driver Name is required" }}
                  register={register}
                  errors={errors}
                  watch={watch}
                />
              </div>
              <div className="col-md-4 my-2">
                <Textbox
                  Label="Contact Number"
                  name={"driverContactNumber"}
                  Placeholder="Contact Number"
                  // validationRules={{ required: "Contact Number is required" }}
                  register={register}
                  errors={errors}
                  watch={watch}
                />
              </div>
              <div className="col-md-4 my-2">
                <Textbox
                  Label="License Number"
                  name={"driverLicenseNumber"}
                  Placeholder="License Number"
                  // validationRules={{ required: "DL Number is required" }}
                  register={register}
                  errors={errors}
                  watch={watch}
                />
              </div>
            </div>

            <div className="row">
              <div style={{ background: "#f5f8fb" }} className="mt-4">
                <strong style={{ fontSize: 20 }} className="w-100 d-block">
                  Freight Detail
                </strong>
              </div>
              <div className="col-md-2 my-2">
                <input
                  {...register("freightDetail", {
                    required: "User is required",
                  })}
                  type="radio"
                  value={"1"}
                  style={{ width: 20, height: 20 }}
                  className="form-check-input shadow-none me-2 mt-0"
                />
                <span>To Pay</span>
              </div>
              <div className="col-md-2 my-2">
                <input
                  {...register("freightDetail", {
                    required: "User is required",
                  })}
                  type="radio"
                  value={"2"}
                  style={{ width: 20, height: 20 }}
                  className="form-check-input shadow-none me-2 mt-0"
                />
                <span>Paid</span>
              </div>
              <div className="col-md-8 my-2">
                <input
                  {...register("freightDetail", {
                    required: "User is required",
                  })}
                  type="radio"
                  value={"3"}
                  style={{ width: 20, height: 20 }}
                  className="form-check-input shadow-none me-2 mt-0"
                />
                <span>To be Billed</span>
              </div>
              <div className="col-md-3 my-2">
                <Textbox
                  disabled={true}
                  Type="number"
                  Label="Basic Freight"
                  name={"basicFreight"}
                  Placeholder="Basic Freight"
                  validationRules={{ required: "Required" }}
                  register={register}
                  errors={errors}
                  watch={watch}
                />
              </div>
              <div className="col-md-3 my-2">
                <Textbox
                  Label="Loading & Unloading Charges"
                  name={"loadingUnloadingCharge"}
                  onKeyUp={() => calculateMainTotalAmount()}
                  Placeholder="Loading & Unloading Charges"
                  // validationRules={{ required: "Required" }}
                  register={register}
                  errors={errors}
                  watch={watch}
                />
              </div>
              <div className="col-md-3 my-2">
                <Textbox
                  Label="Kanta Charge"
                  onKeyUp={() => calculateMainTotalAmount()}
                  name={"kantaCharge"}
                  Placeholder="Kanta Charge"
                  // validationRules={{ required: "Required" }}
                  register={register}
                  errors={errors}
                  watch={watch}
                />
              </div>
              <div className="col-md-3 my-2">
                <Textbox
                  Label="Other Charge"
                  onKeyUp={() => calculateMainTotalAmount()}
                  name={"otherCharge"}
                  Placeholder="Other Charge"
                  // validationRules={{ required: "Required" }}
                  register={register}
                  errors={errors}
                  watch={watch}
                />
              </div>
              <div className="col-md-12 my-4">
                <strong>Sub Total : </strong> {subTotal}
              </div>
              <div className="col-md-3 my-2">
                <SelectBox
                  onChange={() => calculateMainTotalAmount()}
                  Label="GST Rate"
                  name={"gstRate"}
                  validationRules={{ required: "Required" }}
                  register={register}
                  errors={errors}
                  watch={watch}
                >
                  <option value={"0"}>Exampted</option>
                  <option value={"5"}>5%</option>
                  <option value={"12"}>12%</option>
                  <option value={"18"} selected>18%</option>
                  <option value={"28"}>28%</option>
                </SelectBox>
              </div>
              <div className="col-md-3 my-2">
                <SelectBox
                  Label="GST Payable By"
                  name={"gstPayBy"}
                  validationRules={{ required: "Required" }}
                  register={register}
                  errors={errors}
                  watch={watch}
                >
                  <option value={""}>Select Option</option>
                  <option value="1">Consignor</option>
                  <option value="2">Consignee</option>
                  <option value="3">Transporter</option>
                </SelectBox>
              </div>
              <div className="col-md-3 my-2">
                <Textbox
                  Type="number"
                  Label="Advance Paid Amount"
                  name={"advancePaidAmount"}
                  Placeholder="Advance Paid Amount"
                  // validationRules={{ required: "Required" }}
                  register={register}
                  errors={errors}
                  watch={watch}
                />
              </div>
              <div className="col-md-3 my-2">
                <SelectBox
                  Label="Paid Via"
                  name="paidVia"
                  validationRules={{
                    validate: (value) => {
                      const advancePaid = watch("advancePaidAmount");
                      if (advancePaid && !value) return "Required";
                      return true;
                    },
                  }}
                  register={register}
                  errors={errors}
                  watch={watch}
                >
                  <option value="">Select Option</option>
                  <option value="1">Cash</option>
                  <option value="2">Bank</option>
                </SelectBox>
              </div>
              {/* <div className="col-md-4 my-2">
              <Textbox
                Type="number"
                Label="Remaining Amount"
                name={"remainingAmount"}
                Placeholder="Remaining Amount"
                validationRules={{ required: "Required" }}
                register={register}
                errors={errors}
                watch={watch}
              />
            </div> */}
              <div className="col-md-12 mt-4">
                <strong>Total Amount With GST : </strong> {total}
              </div>
            </div>

            <div className="row">
              <div style={{ background: "#f5f8fb" }} className="mt-4">
                <strong style={{ fontSize: 20 }} className="w-100 d-block">
                  Insurance Detail
                </strong>
              </div>
              <div className="col-md-2 my-2">
                <input
                  {...register("isInsured", { required: "Required" })}
                  type="radio"
                  value={false}
                  style={{ width: 20, height: 20 }}
                  className="form-check-input shadow-none me-2 mt-0"
                />
                <span>Not Insured</span>
              </div>
              <div className="col-md-10 my-2">
                <input
                  {...register("isInsured", { required: "Required" })}
                  type="radio"
                  value={true}
                  style={{ width: 20, height: 20 }}
                  className="form-check-input shadow-none me-2 mt-0"
                />
                <span>Insured</span>
              </div>
              {isInsured === "true" && (
                <>
                  <div className="col-md-4 my-2">
                    <Textbox
                      Label="Company Name"
                      name={"insuranceCompanyName"}
                      Placeholder="Company Name"
                      validationRules={{ required: "Required" }}
                      register={register}
                      errors={errors}
                      watch={watch}
                    />
                  </div>
                  <div className="col-md-4 my-2">
                    <Textbox
                      Label="Policy Number"
                      name={"policyNumber"}
                      Placeholder="Policy Number"
                      validationRules={{
                        required: "Policy Number is required",
                      }}
                      register={register}
                      errors={errors}
                      watch={watch}
                    />
                  </div>
                  <div className="col-md-4 my-2">
                    <Textbox
                      Label="Insurance Amount"
                      name={"insuranceAmount"}
                      Placeholder="Insurance Amount"
                      validationRules={{ required: "Amount is required" }}
                      register={register}
                      errors={errors}
                      watch={watch}
                    />
                  </div>
                  <div className="col-md-4 my-2">
                    <Textbox
                      Type="date"
                      Label="Insurance Date"
                      name={"insuranceDate"}
                      Placeholder="Insurance Date"
                      validationRules={{ required: "Date is required" }}
                      register={register}
                      errors={errors}
                      watch={watch}
                    />
                  </div>
                </>
              )}
              <div className="col-md-4 my-2">
                <SelectBox
                  Label="Risk Type"
                  name={"riskType"}
                  validationRules={{ required: "Required" }}
                  register={register}
                  errors={errors}
                  watch={watch}
                >
                  <option value="">Select Option</option>
                  <option value={"1"}>At Owner's Risk</option>
                  <option value={"2"}>At Carrier's Risk</option>
                </SelectBox>
              </div>
              <div className="col-md-4 my-2">
                <SelectBox
                  Label="Mode of Transport"
                  name={"tranportMode"}
                  validationRules={{ required: "Required" }}
                  register={register}
                  errors={errors}
                  watch={watch}
                >
                  <option value="">Select Option</option>
                  <option value={"1"} selected>
                    By Road
                  </option>
                  <option value={"2"}>By Rail</option>
                  <option value={"3"}>By Ocean</option>
                  <option value={"4"}>By Air</option>
                </SelectBox>
              </div>
            </div>

            <div className="row">
              <div style={{ background: "#f5f8fb" }} className="mt-4">
                <strong style={{ fontSize: 20 }} className="w-100 d-block">
                  Detention Details
                </strong>
              </div>
              <div className="col-md-4 my-2">
                <Textbox
                  Label="Detention Charges"
                  name={"detentionCharge"}
                  Placeholder="Detention Charge"
                  register={register}
                  errors={errors}
                  watch={watch}
                />
              </div>
              <div className="col-md-4 my-2">
                <SelectBox
                  Label="Charge Type"
                  name={"chargeType"}
                  validationRules={{
                    validate: (value) => {
                      const detentionCharge = watch("detentionCharge");
                      if (detentionCharge > 0 && !value) return "Required";
                      return true;
                    },
                  }}
                  register={register}
                  errors={errors}
                  watch={watch}
                >
                  <option value={""}>Select Option</option>
                  <option value={"1"}>Fix</option>
                  <option value={"2"}>Per Day</option>
                </SelectBox>
              </div>
              <div className="col-md-4 my-2">
                <Textbox
                  Label="Other Remark"
                  name={"otherRemark"}
                  Placeholder="Other Remark"
                  register={register}
                  errors={errors}
                  watch={watch}
                />
              </div>
            </div>

            <div className="row mb-4">
              <div className="col-md-4 mt-2">
                <Button disabled={isSubmitting} variant="primary" type="submit" className="btn">
                  <FontAwesomeIcon className="me-2" icon={faSave} />
                  Genrate Bilty
                </Button>
              </div>
            </div>
          </form>
        </FormProvider>
      )}
    </div>
  );
};

export default LoadBilty;
